import { BuzerIcon } from "../../../BuzerIcons";

// Floating action button — one global create action, thumb-zone bottom-right.
// 56px, brand-primary. Defaults to the "add" glyph; pass `icon` or children.
export function Fab({ onClick, icon = "add", label = "Pridať", children, style }) {
  return (
    <button type="button" className="bz-fab" onClick={onClick} aria-label={label} style={style}>
      {children || <BuzerIcon name={icon} size={26} color="currentColor" strokeWidth={2.2} />}
    </button>
  );
}
